'use strict';
const treeUtils = require('./tree');
module.exports  = function calculateFishboneLeftToRightLayout(idea, dimensionProvider, margin, layout) {
	const tree = treeUtils.calculateTree(idea, dimensionProvider, margin, 1, 0, layout);
	return tree.toLayout().nodes;
};


